import { Alert } from "@mui/material";

import { SummaryTable } from "@components/SummaryTable/SummaryTable";
import { ConflictingEndorsementsModal } from "@components/EndorsementsModals";

import { PaymentMethods } from "./PaymentMethods";
import { useCheckoutStep } from "./hooks/useCheckoutStep";

export function CheckoutStep() {
  const {
    errorMessage,
    errorRef,
    policyLocator,
    closeModal,
    discardConflicting,
    isOpen,
    saveAndExit,
  } = useCheckoutStep();

  return (
    <>
      {errorMessage && (
        <Alert ref={errorRef} severity="error" sx={{ mb: 3 }}>
          {errorMessage}
        </Alert>
      )}
      <SummaryTable />

      <PaymentMethods policyLocator={policyLocator} />

      <ConflictingEndorsementsModal
        isModalOpen={isOpen}
        onClose={closeModal}
        onSaveAndExit={saveAndExit}
        onDiscardConflicting={discardConflicting}
      />
    </>
  );
}
